import { formatString } from "@/helpers/formatting";

import { axiosClient } from "../client";
import endpoints from "../endpoints";

import type { IWidgetLogo, IWidgetTemplate } from "@/models/widgetTemplates";

class WidgetTemplatesApiService {
  async getWidgetTemplates(clientId: string) {
    const response = await axiosClient.get<{ data: IWidgetTemplate[] }>(
      formatString(endpoints.CLIENTS.WIDGET_TEMPLATES, clientId)
    );
    return response.data.data;
  }

  async updateWidgetTemplate(
    clientId: string,
    template: Partial<IWidgetTemplate>
  ) {
    if (!template.id) {
      return;
    }
    const response = await axiosClient.put<{ data: IWidgetTemplate }>(
      formatString(endpoints.CLIENTS.WIDGET_TEMPLATE, clientId, template.id),
      template
    );
    return response.data.data;
  }

  async deleteWidgetTemplate(clientId: string, template: IWidgetTemplate) {
    const response = await axiosClient.delete<{ data: { deleted: boolean } }>(
      formatString(endpoints.CLIENTS.WIDGET_TEMPLATE, clientId, template.id)
    );
    return response;
  }

  async createWidgetTemplate(
    clientId: string,
    template: Partial<IWidgetTemplate>
  ) {
    const response = await axiosClient.post<{ data: IWidgetTemplate }>(
      formatString(endpoints.CLIENTS.WIDGET_TEMPLATES, clientId),
      template
    );
    return response.data.data;
  }

  async uploadWidgetTemplateLogo(
    clientId: string,
    templateId: number,
    data: FormData,
    additionalConfig: Record<string, unknown> = {}
  ) {
    const response = await axiosClient.post<{ data: IWidgetLogo }>(
      formatString(
        endpoints.CLIENTS.WIDGET_TEMPLATE_LOGO,
        clientId,
        templateId
      ),
      data,
      {
        headers: {
          "content-type": "multipart/form-data",
        },
        ...additionalConfig,
      }
    );
    return response.data.data;
  }

  async deleteWidgetTemplateLogo(clientId: string, templateId: number) {
    await axiosClient.delete(
      formatString(endpoints.CLIENTS.WIDGET_TEMPLATE_LOGO, clientId, templateId)
    );
  }
}

const widgetApiService = new WidgetTemplatesApiService();
export default widgetApiService;
